import React, { useRef, useState } from 'react'
import Navbar from '../../components/Navbar'
import overview_1 from "../../assets/images/contents/overview-1.png"
import overview_2 from "../../assets/images/contents/certificates-permits-licenses-1.png"
import overview_3 from "../../assets/images/contents/overview-3.png"
import overview_4 from "../../assets/images/contents/overview-4.png"
import TechnologyTab from '../../components/TechnologyTab'
import Footer from '../../components/Footer'
import { PrimaryButton, PrimaryButton2th } from '../../components/StyledButtons'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import qr_code_1 from "../../assets/images/contents/overview-qr-code-1.png"
import { useTranslation } from 'react-i18next'
import filter_color from "../../assets/images/design/colorFilter.svg"
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import { Link } from '@mui/material'
import ModalContactGetTrialForm from '../../components/ModalContactGetTrialForm'
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm'

const Overview = () => {
    const { t } = useTranslation()

    const language = useSelector(selectLanguage)

    const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
    const [modalGetTrialOpen, setModalGetTrialOpen] = useState(false);
    const modalDiscussionRef = useRef(null);
    const modalGetTrialRef = useRef(null);
    const handleOverlayClick = (event) => {
        if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
            setModalDiscussionOpen(false)
        }
        if (modalGetTrialRef.current && !modalGetTrialRef.current.contains(event.target)) {
            setModalGetTrialOpen(false)
        }
    };
    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalGetTrialOpen(false)
            setModalDiscussionOpen(false)
        }
    };

    return (
        <div className='overview bg-primary'>
            <div className='color-filter-right' style={{ top: "35%" }}>
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' style={{ top: "70%" }} >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>

            <Navbar />
            <div className='container-fluid overview-header'>
                <div className='container pt-100 pt-md-150'>
                    <div className='col-sm-12 col-md-6 px-md-0 pt-lg-50 pt-f768-t991-0'>
                        <p className='font-64 font-weight-semi-bold header-title pr-xl-130'>{t('overview.header-1')}</p>
                        <p className='font-60 font-weight-semi-bold header-sub-title'>{t('overview.header-2')}</p>
                    </div>
                    <div className='col-sm-12 col-md-6'>
                        <div className='flex justify-center'>
                            <img src={overview_1} alt="overview_1" className='img-responsive' />
                        </div>
                    </div>
                </div>
            </div>
            <TechnologyTab overViewActive={true} />
            <div className='container'>
                <div className='flex justify-center'>
                    <div className='technology-chip'>
                        <p className='text-center header-title font-40 uppercase'>{t('technology-tab.over-view')}</p>
                    </div>
                </div>
                <div className='col-md-6 col-md-offset-3 pt-30'>
                    <p className='text-white text-center'>
                        {t('overview.sub-title')}
                    </p>
                </div>
            </div>
            <div className='container pt-70'>
                <div className='secure-encrypted col-sm-12'>
                    <div className='col-lg-7'>
                        <p className='font-32 font-weight-semi-bold'>{t('overview.title-1')}</p>
                        <p className='font-32 font-weight-semi-bold'>{t('overview.title-1-1')}</p>
                        <p className='pt-30 pb-30 pr-20'>{t('overview.sub-title-1')}</p>
                        <PrimaryButton2th>{t('button.sample-document-with-qrypto-code')}</PrimaryButton2th>
                        {language === "en" ?
                            <p className='pt-30'>For validation, end-users can install the <span className='font-weight-semi-bold'>Document Validator App</span>. You can try the following steps to install it on your mobile phone:</p>
                            :
                            <p className='pt-30'>Để xác thực, người dùng cuối có thể cài đặt <span className='font-weight-semi-bold'>Ứng dụng Trình xác thực tài liệu</span>. Bạn có thể thử các bước sau để cài đặt nó trên điện thoại di động của mình:</p>
                        }
                        {language === "en" ?
                            <ul className='list-unstyled'>
                                <li className='checked-line-secondary'>
                                    <p>
                                        <span className='font-weight-semi-bold '>On your mobile,</span> visit <Link href='https://validation.qrypto.ee' target='_blank' >https://validation.qrypto.ee</Link> and follow <span className='font-weight-semi-bold '>one of these 3 methods</span> :
                                    </p>
                                    <ul className='list-unstyled'>
                                        <li className='text-grey'>(a) Click on the <span className='font-weight-semi-bold text-primary'>Use Camera</span> button to scan the code directly using the browser camera or</li>
                                        <li className='text-grey'>(b) <span className='font-weight-semi-bold text-primary'>Upload Image/PDF file</span> button to upload the image or PDF file containing the code or</li>
                                        <li className='text-grey'>(c) <span className='font-weight-semi-bold text-primary'>Install</span> the app</li>
                                    </ul>
                                </li>
                                <li className='checked-line-secondary text-grey'>
                                    <span className='font-weight-semi-bold text-primary'>After the app has been installed,</span> scan the code above
                                </li>
                            </ul>
                            :
                            <ul className='list-unstyled'>
                                <li className='checked-line-secondary'>
                                    <p>
                                        <span className='font-weight-semi-bold '>Trên điện thoại di động của bạn,</span> hãy truy cập <Link href='https://validation.qrypto.ee' target='_blank' >https://validation.qrypto.ee</Link> và làm theo <span className='font-weight-semi-bold '>một trong 3 phương pháp sau</span>:
                                    </p>
                                    <ul className='list-unstyled'>
                                        <li className='text-grey'>(a) Bấm vào nút <span className='font-weight-semi-bold text-primary'>Sử dụng Camera</span> để quét mã trực tiếp bằng camera trình duyệt hoặc</li>
                                        <li className='text-grey'>(b) <span className='font-weight-semi-bold text-primary'>Nút Tải lên tệp Hình ảnh/PDF</span> để tải lên hình ảnh hoặc tệp PDF có chứa mã hoặc</li>
                                        <li className='text-grey'>(c) <span className='font-weight-semi-bold text-primary'>Cài đặt</span> ứng dụng</li>
                                    </ul>
                                </li>
                                <li className='checked-line-secondary text-grey'>
                                    <span className='font-weight-semi-bold text-primary'>Sau khi ứng dụng đã được cài đặt,</span> quét mã ở trên
                                </li>
                            </ul>
                        }
                    </div>
                    <div className='col-lg-5 pt-lg-100'>
                        <div className='flex justify-center'>
                            <img src={qr_code_1} alt="qr_code_1" className='img-responsive' />
                        </div>
                    </div>
                    <div className='col-sm-12 pt-30'>
                        <p>{t('overview.content-1')}</p>
                        <p className='font-weight-semi-bold pb-20'>{t('overview.content-1-1')}</p>
                        <PrimaryButton2th
                        onClick={() => setModalDiscussionOpen(true)}
                        >{t('button.schedule-discussion')}</PrimaryButton2th>
                    </div>
                </div>
            </div>

            <div className='container pt-50'>
                <div className='rest-api col-sm-12'>
                    <div className='col-lg-5 pt-lg-70 pb-20'>
                        <p className='text-white font-40 font-weight-semi-bold'>{t('overview.title-2')}</p>
                        <p className='text-white pt-30'>{t('overview.sub-title-2')}</p>
                        <p className='text-white pb-30'>{t('overview.sub-title-2-2')}</p>
                        <PrimaryButton
                        onClick={() => setModalGetTrialOpen(true)}
                        >{t('button.sign-up-for-free')}</PrimaryButton>
                    </div>
                    <div className='col-lg-6 col-lg-offset-1'>
                        <img src={overview_2} alt="" className='img-responsive' />
                    </div>
                </div>
            </div>

            <div className='container mt-50'>
                <div className='qrypto-secure col-sm-12'>
                    <div className='col-lg-6 pt-lg-30 pb-30'>
                        <img src={overview_3} alt="" className='img-responsive' />
                    </div>
                    <div className='col-lg-6'>
                        <p className='font-32'>{t('overview.title-3')}</p>
                        <p className='pt-30 pb-20'>{t('overview.sub-title-3')}</p>
                        {language === "en"
                        ?
                        <ul className='list-unstyled'>
                            <li className='checked-line-secondary text-grey'><span className='font-weight-semi-bold text-primary'>Primary Data Codes (PDC):</span> These are self- contained codes which encapsulate all the information within the code itself. The recommended capacity of these codes is about 2,000 characters – large enough for a textual bank account statement like the sample given above.</li>
                            <li className='checked-line-secondary text-grey'><span className='font-weight-semi-bold text-primary'>Extended Data Codes (EDC):</span> These codes can also contain attachments like images and PDF files. The attachments are encrypted and stored as BLOBS in object-store. The decryption key and their fingerprints are stored within the QR. This prevents any subsequent tampering of the codes.</li>
                            <li className='checked-line-secondary font-weight-semi-bold'>Both the codes can be revoked or chained with a new code.</li>
                        </ul>
                        :
                        <ul className='list-unstyled'>
                            <li className='checked-line-secondary text-grey'><span className='font-weight-semi-bold text-primary'>Mã dữ liệu chính (PDC):</span> Đây là những mã độc lập gói gọn tất cả thông tin bên trong chính mã đó. Dung lượng khuyến nghị của các mã này là khoảng 2.000 ký tự – đủ lớn cho bản sao kê tài khoản ngân hàng dạng văn bản như mẫu được đưa ra ở trên.</li>
                            <li className='checked-line-secondary text-grey'><span className='font-weight-semi-bold text-primary'>Mã dữ liệu mở rộng (EDC):</span> Các mã này cũng có thể chứa các tệp đính kèm như hình ảnh và tệp PDF. Các tệp đính kèm được mã hóa và lưu trữ dưới dạng BLOBS trong kho đối tượng. Khóa giải mã và dấu vân tay của chúng được lưu trữ trong QR. Điều này ngăn chặn mọi hành vi giả mạo mã sau này.</li>
                            <li className='checked-line-secondary font-weight-semi-bold'>Cả hai mã đều có thể bị thu hồi hoặc bị xâu chuỗi bằng mã mới.</li>
                        </ul>
                        }
                    </div>

                </div>
            </div>

            <div className='container pt-50'>
                <div className='edc-architecture col-sm-12'>
                    <div className='col-lg-6 pt-lg-100 pb-20'>
                        <p className='text-white font-40 font-weight-semi-bold'>{t('overview.title-4')}</p>
                        {language === "en"
                        ?
                        <p className='text-white pt-30 pb-30'>Here’s our EDC architecture. The easiest way to understand this cutting edge technology is by signing up for <span className='font-weight-semi-bold'>a free trial account</span></p>
                        :
                        <p className='text-white pt-30 pb-30'>Đây là kiến ​​trúc EDC của chúng tôi. Cách dễ nhất để hiểu công nghệ tiên tiến này là đăng ký <span className='font-weight-semi-bold'>tài khoản dùng thử miễn phí</span></p>
                        }
                        <PrimaryButton
                        onClick={() => setModalGetTrialOpen(true)}
                        >{t('button.sign-up-for-free')}</PrimaryButton>
                    </div>
                    <div className='col-lg-6'>
                        <img src={overview_4} alt="" className='img-responsive' />
                    </div>
                </div>
            </div>


            <div className='container'>
                <IndustriesImageContainer />
            </div>
            <Footer />
            {modalDiscussionOpen && <ModalContactDiscussionForm
                setOpenModal={setModalDiscussionOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalDiscussionRef} />}
            {modalGetTrialOpen && <ModalContactGetTrialForm
                setOpenModal={setModalGetTrialOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalGetTrialRef} />}
        </div>
    )
}

export default Overview